import { TTableSort } from 'src/components/table/thead/col';

import { TProductFullListSortCol } from './product-full.type';


export type TAccountProductFullListQuery = {
	limit: number;
	offset: number;
	search?: string;
	searchBrandName?: string;
	searchSerialNumber?: string;
	searchProvider?: string;
	searchName?: string;
	searchStorageName?: string;
	sort?: TTableSort;
	sortCol?: TProductFullListSortCol;
	isAnalogues?: boolean;
	brandId?: number;
	serialNumber?: string;
};

export type TAccountProductFullListQueryRequest = {
	limit?: number;
	offset?: number;
	search?: string;
	sort?: string;
	sort_col?: string;
	is_analogues?: boolean;
	brand_id?: number;
	serial_number?: string;
};

export function adaptAccountProductFullListQueryToRequest(data?: TAccountProductFullListQuery): TAccountProductFullListQueryRequest {
	if (!data) {
		return {};
	}

	const {
		sortCol,
		...restFields
	} = data;

	return {
		sort_col: sortCol,
		...restFields
	};
}

export type TAccountProductFullPayloadRequest = {
	serialNumber: string;
	brandId?: number;
	isAnalogues: boolean;
};

export type TAccountProductFullRequest = {
	serial_number: string;
	brand_id?: number;
	is_analogues: boolean;
};

export type TAccountProductFullHistoryItem = TAccountProductFullPayloadRequest & {
	date: string;
	key: string;
};

export function adaptAccountProductFullToRequest(data: TAccountProductFullPayloadRequest): TAccountProductFullRequest {
	const {
		serialNumber,
		brandId,
		isAnalogues,
	} = data;

	return {
		serial_number: serialNumber,
		brand_id: brandId,
		is_analogues: isAnalogues,
	};
}
